import React from "react"
import Image from "next/image"
import { TableOrder, OrderType } from "@/types/orders.types"
import { ProvidersType } from "@/types/providers.types"
import { OrderStatusesTypes } from "@/types/statuses.types"
import { EditOutlined } from "@ant-design/icons"
import { dispatchPageModalsAtom, defaultModalsState } from "@/atoms/dispatchPageModalsAtom"
import { useSetRecoilState } from "recoil"
import { useTranslation } from "react-i18next"

interface DropoffStopsCountProps {
  order: TableOrder
  dropoffTime?: string
  isEditable?: boolean
}

const DropoffStopsCount: React.FC<DropoffStopsCountProps> = ({
  order,
  dropoffTime,
  isEditable,
}) => {
  const { t } = useTranslation()
  const setDispatchPageModals = useSetRecoilState(dispatchPageModalsAtom)

  const isDropoffEditable =
    isEditable &&
    order.provider === ProvidersType.OWN_FLEET &&
    ![
      OrderStatusesTypes.DELIVERED,
      OrderStatusesTypes.CANCELLED,
      OrderStatusesTypes?.RETURNED,
    ].includes(order?.isChildren ? order?.parentStatus! : order?.status!)

  return (
    <>
      <div
        className={`flex flex-row items-center whitespace-nowrap w-fit group ${
          isDropoffEditable && "cursor-pointer"
        }`}
        {...(isDropoffEditable
          ? {
              onClick: () =>
                setDispatchPageModals({
                  ...defaultModalsState,
                  editOrderDrawerInstance: { ...order, type: OrderType.ACTIVE },
                }),
            }
          : {})}
      >
        <div className="flex w-5 h-5 mr-2 bg-kosmoLightGray rounded-md items-center justify-center">
          <Image
            src="/assets/images/multi-location.svg"
            alt="logo"
            priority={true}
            width={16}
            height={16}
          />
        </div>
        <p className="flex flex-shrink-0 my-auto font-medium text-black lowercase">
          {order?.recipients.length}{" "}
          {order?.recipients?.length > 1 ? t("common.stops") : t("common.stop")}
        </p>
        {isDropoffEditable && (
          <EditOutlined
            className="ml-1 invisible group-hover:visible"
            hidden={!isDropoffEditable}
          />
        )}
      </div>
      {dropoffTime && <p className="flex-shrink-0 text-gray-500">{dropoffTime}</p>}
    </>
  )
}

export default DropoffStopsCount
